/// <reference path="../../../../tools/typings/angularjs/angular.d.ts"/>
/// <reference path="../../../services/contract/contract_interfaces.ts"/>

module DealerwareWebComponents {
    "use strict";

    export class ContractVehicleIssuesDirectiveController {
        public static $inject: string[] = [
            '$timeout',
            '$scope',
            '$state',
            '$mdMedia',
            '$mdDialog',
            'DataUtils',
            '$mobilityCompanyAuthentication',
            '$dealerwareLoading',
            '$dealerwareNotification',
            'DealerwareIssueModel',
            '$filter'
        ];

        public contract: any;
        public issueColumns: any;
        public vehicleColumns: any;
        public issue: any;
        public loader: any;

        constructor(
                    public $timeout: any,
                    public $scope: any,
                    public $state: any,
                    public $mdMedia: any,
                    public $mdDialog: any,
                    public DataUtils: any,
                    public $mobilityCompanyAuthentication: any,
                    public $dealerwareLoading: any,
                    public $dealerwareNotification: any,
                    public DealerwareIssueModel: any,
                    public $filter: any) {

            this.initIssueColumns();
        }

        public pageTransitionError(response : any) : void {
            this.loader.close();
            this.$dealerwareNotification.apiError(response);
        }

        public initIssueColumns() : void {
            var _self = this,
                time_zone = this.$mobilityCompanyAuthentication.location.time_zone_name;

            this.issueColumns = [{
                key: 'id',
                hidden: true
            },{
                key: 'created_at',
                header: 'Created',
                dataFilter: (ts: string) => {
                    return ts ? this.$filter('filterInternationalizationDate')(this.DataUtils.getInstance().formatTimestampSimple(ts, time_zone)) : '';
                }
            },{
                key: 'car.license',
                header: 'Vehicle',
                onClick: function(e: any, issue: any) {
                    $(e.target).attr('href', _self.$state.href(
                        'root.private.application.vehicles.details',
                        { vehicleId: issue.data.car.id }
                    ));
                }
            },{
                key: 'created_by',
                header: 'Created By',
                onClick: function(e: any, issue: any) {
                    $(e.target).attr('href', _self.$state.href(
                        'root.private.application.employees.details',
                        { employeeId: issue.data.created_by_id }
                    ));
                }
            },{
                key: 'description',
                header: 'Description'
            },{
                key: 'current_state',
                header: 'Status'
            },{
                header: '',
                actionColumn: true,
                actions: [{
                    hideFn: function(issue: any) { return issue.data.image_count < 1; },
                    iconFn: function() { return 'image'; },
                    tooltip: 'View Issue Images',
                    onClick: function(issue: any) { _self.openIssueImagesModal(issue); }
                },{
                    iconFn: function() { return 'magnify'; },
                    tooltip: 'View Issue',
                    onClick: function(issue: any) { _self.openIssueModal(issue); }
                }]
            }];
        }

        public loadVehicleIssues() : void {
            var _self = this;

            var loader = this.$dealerwareLoading.show('Loading...');
            this.contract.loadVehicleIssues().then(
                function() {
                    loader.close();
                },
                function(response: any) {
                    loader.close();
                    _self.$dealerwareNotification.apiError(response);
                }
            );
        }

        public get useFullScreen() {
            return this.$mdMedia('xs') || this.$mdMedia('sm');
        }

        public get vehicleIssueImagesModalController() {
            return function($scope: any, $mdDialog: any, images: any) {
                $scope.images = images;

                $scope.cancel = function() : void {
                    $mdDialog.hide();
                }
            }
        }

        public get vehicleIssueModalController() {
            var _self = this;

            return function($scope: any, $mdDialog: any, contract: any, issue: any) {
                $scope.contract = contract;
                $scope.issue = issue;

                $scope.cancel = function() : void {
                    $mdDialog.hide();
                };

                $scope.isNewIssue = function() : boolean {
                    return $scope.issue && $scope.issue.data && !$scope.issue.data.id;
                };

                $scope.isClosedIssue = function() : boolean {
                    return $scope.issue && $scope.issue.data && $scope.issue.data.closed_at
                };

                $scope.hasContract = function() : boolean {
                    return $scope.issue && $scope.issue.data && ($scope.issue.data.reservation || $scope.issue.data.reservation_id);
                };

                $scope.createIssue = function() : void {
                    $scope.issue.$create({
                        promise: true,
                        params: { location_id: $scope.contract.locationId }
                    }).then(
                        function(response: any) {
                            $mdDialog.hide();
                            _self.loadVehicleIssues();
                        },
                        function(response: any) {
                            _self.$dealerwareNotification.apiError(response);
                        }
                    );
                };

                $scope.resolveIssue = function() : void {
                    $scope.issue.$delete({
                        promise: true,
                        params: {
                            location_id: $scope.contract.locationId,
                            vehicle_id: $scope.issue.data.car.id
                        }
                    }).then(
                        function(response: any) {
                            $mdDialog.hide();
                            _self.loadVehicleIssues();
                        },
                        function(response: any) {
                            _self.$dealerwareNotification.apiError(response);
                        }
                    );
                };

                $scope.showVehicleSelectModal = function() : void {
                    $mdDialog.show({
                        templateUrl: '/components/contract/vehicle_issues/vehicle_select_modal.html',
                        controller: _self.vehicleSelectModalController,
                        locals: {
                            contract: $scope.contract,
                            issue: $scope.issue
                        },
                        preserveScope: true,
                        multiple: true,
                        clickOutsideToClose: false,
                        fullscreen: _self.useFullScreen
                    });
                };

                $scope.openVehicleSelectModal = function() : void {
                    if ($scope.contract.vehicles) {
                        $scope.showVehicleSelectModal();
                    } else {
                        this.contract.loadVehicleContracts().then(
                            function() { $scope.showVehicleSelectModal(); },
                            function(response: any) { _self.$dealerwareNotification.apiError(response); }
                        );
                    }
                };
            };
        }

        public get vehicleSelectModalController() {
            var _self = this;

            return function($scope: any,
                            $mobilityCompanyAuthentication: any,
                            $mdDialog: any,
                            DataUtils: any,
                            contract: any,
                            issue: any,
                            $filter: any) {
                var dataUtils = DataUtils.getInstance(),
                    time_zone = $mobilityCompanyAuthentication.location.time_zone_name;

                $scope.mainController = _self;
                $scope.contract = contract;
                $scope.issue = issue;
                $scope.vehicleColumns = [{
                    key: 'id',
                    hidden: 'true'
                },{
                    header: '',
                    iconFn: function() { return 'flag'; },
                    tooltip: 'Select This Vehicle',
                    onClick: function(record: any) {
                        $scope.issue.data.vehicle_id = record.data.car_id;
                        $scope.issue.data.car = { license: record.data.car.license };
                        $scope.issue.data.reservation_id = record.data.reservation_id;
                        $mdDialog.hide();
                    }
                },{
                    key: 'car.vin',
                    header: 'VIN'
                },{
                    key: 'car.license',
                    header: 'License Plate'
                },{
                    key: 'started_at',
                    header: 'Started',
                    dataFilter: (ts: string) => {
                        return (ts && $filter !== undefined) ? $filter('filterInternationalizationDate')(dataUtils.formatTimestampSimple(ts, time_zone)) : '';
                    }
                },{
                    key: 'finished_at',
                    header: 'Finished',
                    dataFilter: (ts: string) => {
                        return (ts && $filter !== undefined) ? $filter('filterInternationalizationDate')(dataUtils.formatTimestampSimple(ts, time_zone)) : '';
                    }
                }];

                $scope.cancel = function() : void {
                    $mdDialog.hide();
                };
            };
        }

        public openIssueImagesModal(record: any) {
            var _self = this;

            this.DealerwareIssueModel.loadIssueImages({
                promise: true,
                params: {
                    location_id: this.contract.locationId,
                    vehicle_id: record.data.car.id,
                    id: record.data.id
                }
            }).then(
                function(images: any) {
                    _self.$mdDialog.show({
                        templateUrl: '/components/contract/vehicle_issues/contract_vehicle_issue_images_modal.html',
                        controller: _self.vehicleIssueImagesModalController,
                        locals: { images: images.data },
                        clickOutsideToClose: false,
                        fullscreen: _self.useFullScreen
                    });
                },
                function(response: any) { _self.$dealerwareNotification.apiError(response); }
            );
        }

        public openIssueModal(record?: any) : void {
            this.$mdDialog.show({
                templateUrl: '/components/contract/vehicle_issues/contract_vehicle_issue_modal.html',
                controller: this.vehicleIssueModalController,
                locals: {
                    contract: this.contract,
                    issue: record || new this.DealerwareIssueModel()
                },
                clickOutsideToClose: false,
                fullscreen: this.useFullScreen
            });
        }
    }

    getDealerwareWebComponentsModule().controller('ContractVehicleIssuesDirectiveController',ContractVehicleIssuesDirectiveController);

    export class ContractVehicleIssuesDirective implements ng.IDirective {
        public restrict         : string    =   'E';
        public controller       : any       =   'ContractVehicleIssuesDirectiveController';
        public controllerAs     : string    =   'contractVehicleIssuesController';
        public bindToController : boolean   =   true;
        public replace          : boolean   =   false;
        public scope            : Object    =   {contract: '='};
        public transclude       : boolean   =   false;
        public templateUrl      : string    =   '/components/contract/vehicle_issues/contract_vehicle_issues_directive.html';
        public static $inject   : string[]  =   [];

        constructor() {}

        public link : ng.IDirectiveLinkFn = (
            scope   :   any,
            element :   ng.IAugmentedJQuery,
            attrs   :   ng.IAttributes,
            ctrls   :   any
        ) => {}
    }

    // register the directive
    getDealerwareWebComponentsModule().directive("dealerwareContractVehicleIssues",() => new ContractVehicleIssuesDirective());
 }
